'use client';

import { createContext, FC, ReactNode, useContext } from 'react';

import { useModal } from '@/hooks/useModal';

interface AboutUsVideoData {
	videoLink: string;
	videoThumbnailUrl?: string;
}

interface AboutUsVideoContextValue {
	openAboutUsVideo: () => void;
	videoData: AboutUsVideoData;
}

const AboutUsVideoContext = createContext<AboutUsVideoContextValue | undefined>(undefined);

interface AboutUsVideoProviderProps {
	children: ReactNode;
	videoData: AboutUsVideoData;
}

export const AboutUsVideoProvider: FC<AboutUsVideoProviderProps> = ({ children, videoData }) => {
	const { openModal } = useModal();

	const openAboutUsVideo = () => {
		openModal('ABOUT_US_VIDEO', {
			videoLink: videoData.videoLink,
			thumbnailUrl: videoData.videoThumbnailUrl
		});
	};

	return (
		<AboutUsVideoContext.Provider value={{ openAboutUsVideo, videoData }}>
			{children}
		</AboutUsVideoContext.Provider>
	);
};

export const useAboutUsVideo = (): AboutUsVideoContextValue | undefined =>
	useContext(AboutUsVideoContext);
